export default __webpack_public_path__ + "static/media/capacitorjs.7517cfe2.svg";